import PolicyPDF from "../components/PolicyPDF";
import "../css/policy.css";

const sections = [
  {
    title: "1. General Policy",
    paragraphs: [
      "Because printing orders are often produced specifically to a customer's requested specifications, refunds are considered based on the stage of the order and the circumstances involved.",
    ],
  },
  {
    title: "2. Before Production",
    paragraphs: [
      "If an order is cancelled before production has started, IGC Print Press may review the request and determine whether a refund is available.",
      "Any costs already incurred for artwork preparation, design, materials, processing, or other approved work may be deducted where applicable.",
    ],
  },
  {
    title: "3. After Production Has Started",
    paragraphs: [
      "Once production has started, a full refund may not be available because materials, labour, machine time, and other production resources may already have been committed to the order.",
    ],
  },
  {
    title: "4. Defective or Incorrect Orders",
    paragraphs: [
      "If an order has a significant production defect or does not materially match the agreed specifications due to an error on our part, the customer should contact us as soon as possible.",
      "We may review the issue and, where appropriate, offer a correction, reprint, replacement, or other reasonable resolution.",
    ],
  },
  {
    title: "5. Customer-Supplied Artwork",
    paragraphs: [
      "IGC Print Press is not responsible for errors contained in customer-approved artwork, including spelling mistakes, incorrect contact information, incorrect colours, or incorrect dimensions that were visible before production.",
    ],
  },
  {
    title: "6. Refund Requests",
    paragraphs: [
      "Refund requests should include the customer's name, order details, and a clear explanation of the reason for the request.",
      "Requests may be reviewed against the original quotation, approved artwork, payment records, and production status.",
    ],
  },
  {
    title: "7. Delivery and Collection",
    paragraphs: [
      "A delivery issue does not automatically qualify an order for a refund. We will review the circumstances and work with the customer to resolve the issue where reasonably possible.",
    ],
  },
  {
    title: "8. Refund Processing",
    paragraphs: [
      "Where a refund is approved, the method and timing of the refund will depend on the original payment method and the applicable processing requirements.",
    ],
  },
  {
    title: "9. Contact",
    paragraphs: [
      "For refund enquiries, contact IGC Print Press on +234 803 773 8028.",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <div className="policy-page">
      <div className="wrap">
        <div className="policy-hero">
          <span className="hero-tag">
            <span className="pulse" />
            IGC PRINT PRESS
          </span>

          <h1 className="policy-title">
            Refund Policy
          </h1>

          <p className="policy-intro">
            Our refund policy explains how payments, cancellations,
            production issues, and refund requests are handled for
            printing orders.
          </p>

          <span className="policy-updated">
            Last updated: September 2026
          </span>
        </div>

        <PolicyPDF
          title="Refund Policy"
          filename="IGC-Print-Press-Refund-Policy.pdf"
          sections={sections}
        >
          <div className="policy-content">
            {sections.map((section) => (
              <section key={section.title}>
                <h2>{section.title}</h2>

                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </section>
            ))}
          </div>
        </PolicyPDF>
      </div>
    </div>
  );
}